var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "order" },
          [
            _c("OrderCard", {
              staticClass: "order__card",
              attrs: { order: _vm.order }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasOptedInInsurance
          ? _c("div", { staticClass: "insurance-confirmation" }, [
              _c(
                "div",
                { staticClass: "insurance-confirmation__logo" },
                [_c("allianz-logo", { staticClass: "allianz-logo" })],
                1
              ),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.trackingPixelHtml
          ? _c("div", {
              domProps: { innerHTML: _vm._s(_vm.trackingPixelHtml) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isCjTrackingPixel
          ? _c("iframe", {
              attrs: {
                height: "1",
                width: "1",
                frameborder: "0",
                scrolling: "no",
                src:
                  "https://www.emjcd.com/tags/c?" +
                  "containerTagId=" +
                  encodeURIComponent(this.$config.cjEnterpriseId) +
                  "&ITEM1=" +
                  encodeURIComponent(_vm.order.ticket.id) +
                  "&AMT1=" +
                  encodeURIComponent(_vm.order.payment.paid) +
                  "&QTY1=" +
                  encodeURIComponent(_vm.order.ticket.quantity) +
                  "&CJEVENT=" +
                  encodeURIComponent(this.$store.state.cjEventId) +
                  "&CID=" +
                  encodeURIComponent(this.$config.cjEnterpriseId) +
                  "&OID=" +
                  encodeURIComponent(_vm.order.id) +
                  "&TYPE=" +
                  encodeURIComponent(
                    _vm.order.customer.is_new
                      ? _vm.CJ_NEW_USER_TYPE_ID
                      : _vm.CJ_RETURNING_USER_TYPE_ID
                  ) +
                  "&CURRENCY=" +
                  encodeURIComponent(_vm.order.payment.currency),
                name: "Conversion",
                tag: ""
              }
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "insurance-confirmation__info" }, [
      _c("p", [
        _vm._v(
          "\n                Thank you for choosing Allianz to insure your experience. You will receive a separate email providing\n                you an update around the status of your policy purchase within the next 24 hours.\n            "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }